exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drag-drop-item{background-color:inherit;position:relative}.drag-drop-item .border-bottom,.drag-drop-item .border-top{position:absolute;left:12px;right:12px;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.drag-drop-item .border-top{top:0}.drag-drop-item .border-bottom{bottom:0}", ""]);

// exports
